// extracted by mini-css-extract-plugin
module.exports = {"jobs_count_container":"company_jobs_count_container__2Ew8V"};